module.exports = __webpack_public_path__ + "assets/bolt-ai.11abcaf2.svg";